import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

/**
 *  NAV TECHNIKAI FELHASZNÁLÓ egy cégnél az alrendszerben (backend/nav-technikai.js).
 *
 *  Kapcsolt módban a Könyvelésben megadott felhasználót használja – itt csak tájékoztat (és
 *  kipróbálható). Önálló módban (saját ügyfél) itt adható meg: felhasználó, jelszó, aláíró- és
 *  cserekulcs, adószám, és a TESZT (sandbox) jelölő – ez dönti el, hogy a teszt vagy az éles NAV-hoz
 *  megy-e a számla és a nyugta-adatszolgáltatás.
 */
@Component({
  selector: 'app-nav-technikai-beallitas',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './nav-technikai-beallitas.component.html',
  styleUrls: ['./nav-technikai-beallitas.component.scss'],
})
export class NavTechnikaiBeallitasComponent implements OnChanges {
  @Input() alrendszer = '';
  @Input() ugyfelId: string | null = null;
  /** Írhat-e (a modul jogából; a kiszolgáló is ellenőrzi). */
  @Input() ir = true;
  @Output() valtozott = new EventEmitter<void>();

  a: any = null;
  urlap: any = null;
  fut = false;
  hiba = '';
  uzenet = '';

  constructor(private http: HttpClient) {}
  private get ut() { return `/api/nav-technikai/${this.alrendszer}/${this.ugyfelId}`; }

  async ngOnChanges() {
    this.a = null; this.urlap = null; this.hiba = ''; this.uzenet = '';
    if (!this.alrendszer || !this.ugyfelId) return;
    try {
      this.a = await firstValueFrom(this.http.get(this.ut));
      if (this.a.szerkesztheto) this.urlap = { login: this.a.login || '', adoszam: this.a.adoszam || '', sandbox: !!this.a.sandbox, jelszo: '', signkey: '', exchangekey: '' };
    } catch (e: any) { this.hiba = e?.error?.error || 'A NAV-beállítás nem tölthető be.'; }
  }

  async ment() {
    this.fut = true; this.hiba = ''; this.uzenet = '';
    try {
      await firstValueFrom(this.http.put(this.ut, this.urlap));
      this.uzenet = 'Mentve.';
      await this.ngOnChanges();
      this.uzenet = 'Mentve.';
      this.valtozott.emit();
    } catch (e: any) { this.hiba = e?.error?.error || 'A mentés nem sikerült.'; }
    this.fut = false;
  }
  async proba() {
    this.fut = true; this.hiba = ''; this.uzenet = '';
    try {
      const r: any = await firstValueFrom(this.http.post(this.ut + '/proba', {}));
      this.uzenet = `A NAV elfogadta a belépést (${r.teszt ? 'TESZT' : 'éles'} környezet).`;
    } catch (e: any) { this.hiba = e?.error?.error || 'A kapcsolat próbája nem sikerült.'; }
    this.fut = false;
  }
}
